import { render } from "./manageAccount.vue?vue&type=template&id=10a0f29a"
import script from "./manageAccount.vue?vue&type=script&lang=js"
export * from "./manageAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__